import React from 'react';
import Select, { components } from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { setSelectedAgency } from 'slices/auth/reducer';
import { Agency } from 'types/user';


const AgencyDropdownFullWidth = () => {

    const dispatch: AppDispatch = useDispatch();

    const agencies = useSelector((state: RootState) => state.auth.user?.agencies);
    // const agencies = agencies_?.[0] ? [agencies_[0]] : []
    const selectedAgency = useSelector((state: RootState) => state.auth.selectedAgency);

    const changeAgency = (agency: Agency) => {
        if (agency.uuid === selectedAgency?.uuid) return;
        dispatch(setSelectedAgency(agency));
        setTimeout(() => { window.location.href = '/'; }, 300)
    };

    const SingleValue = (props: any) => (
        <components.SingleValue {...props}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingRight: '16px' }}>
                <i className="bx bx-buildings fs-5" />
                {props.children}
            </div>
        </components.SingleValue>
    );

    const DropdownIndicator = (props: any) => {
        const { options } = props.selectProps;
        if (options.length <= 1) return null; // hide arrow
        return <components.DropdownIndicator {...props} />;
    };

    return (
        <React.Fragment>
            <Select
                className="agency-select"
                classNamePrefix="rs"
                components={{ SingleValue, DropdownIndicator }}
                options={(agencies ?? []).map(a => ({ label: a.name, value: a.uuid })).sort((a, b) => a.label.localeCompare(b.label))}
                isSearchable={!((agencies ?? []).length <= 1)}
                menuIsOpen={(agencies ?? []).length <= 1 ? false : undefined}
                onMenuOpen={((agencies ?? []).length <= 1) ? (() => {}) : undefined}
                styles={{
                    menu: (base) => ({
                      ...base,
                      right: 0,
                      left: "auto",
                    }),
                  }}
                value={
                    selectedAgency
                        ? { label: selectedAgency.name, value: selectedAgency.uuid }
                        : null
                }

                onChange={(opt) => {
                    const agency = agencies?.find(a => a.uuid === opt?.value);
                    if (agency) changeAgency(agency);
                }}
            />
        </React.Fragment>
    );
};

export default AgencyDropdownFullWidth;